import axios from 'axios';

// ✅ Detecta o ambiente e usa a porta 8000 para o FastAPI (Python)
const isLocal = window.location.hostname === 'localhost';

export const BACKEND_URL = isLocal 
  ? 'http://localhost:8000' 
  : 'https://backend-empregos.onrender.com'; 

export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// Adiciona o token nas requisições automaticamente
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// --- UPLOAD ---
export const uploadAPI = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file); 
    return API.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

// --- AUTENTICAÇÃO ---
export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getMe: () => API.get('/auth/me'),
};

// --- VAGAS (JOBS) ---
export const jobsAPI = {
  getAll: (params) => API.get('/jobs', { params }),
  getById: (idOrSlug) => API.get(`/jobs/${idOrSlug}`),
  create: (data) => {
    const isFormData = data instanceof FormData;
    return API.post('/jobs', data, {
      headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {}
    });
  },
  createPublic: (data) => API.post('/jobs/public', data),
  update: (id, data) => API.put(`/jobs/${id}`, data), 
  delete: (id) => API.delete(`/jobs/${id}`),
};

// --- CANDIDATURAS ---
export const applicationsAPI = {
  apply: (data) => API.post('/applications', data),
  getMy: () => API.get('/applications/my'),
};

// --- FAVORITOS ---
export const favoritesAPI = {
  toggle: (jobId) => API.post(`/favorites/${jobId}`),
  getAll: () => API.get('/favorites'),
};

// --- CONTATO (Resolve o erro da ContactPage) ---
export const contactAPI = {
  submit: (data) => API.post('/contact', data),
};

// --- BLOG ---
export const blogAPI = {
  getAll: (category) => API.get('/blog', { params: { category } }),
  getById: (id) => API.get(`/blog/${id}`),
  create: (formData) => API.post('/blog', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => API.delete(`/blog/${id}`),
};

// --- SISTEMA ---
export const statsAPI = {
  get: () => API.get('/stats'),
};

export const seedAPI = {
  seed: () => API.post('/seed'),
};

export default API;